import { useContext, useEffect } from "react";
import { BotContext } from "./store";
import { useDispatch, useSelector } from "react-redux";
import { State } from "@/redux/Types";
import { userSlice } from "@/redux/User";
import useBotSave from "./react-query/useBotSave";

export const outgrowOrigin = new URL(document.referrer).origin;

export function sendEventToOutgrow(event: CbbEvent) {
  window.parent?.postMessage(event, {
    targetOrigin: outgrowOrigin,
  });
}

export function useOutgrowEventHandler() {
  const dispatch = useDispatch();
  const [store, storeDispatch] = useContext(BotContext);
  const { mutateAsync: saveBot } = useBotSave();
  const fromOutgrow = useSelector((state: State) => state.user.fromOutgrow);

  useEffect(() => {
    function handler(event: MessageEvent<OutgrowEvent>) {
      if (event.origin !== outgrowOrigin) return;
      console.log("outgrow event: ", event.data);

      switch (event.data.type) {
        case "changeBotOgUrl": {
          if (event.data.payload.success) {
            const botData = {
              ...store.botData,
              outgrowData: {
                ...store.botData.outgrowData,
                url: event.data.payload.url,
              },
            };

            storeDispatch({ type: "set-botData", botData });
            saveBot(botData);

            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "success",
                message: "URL Updated Successfully",
              }),
            );
          } else {
            dispatch(
              userSlice.actions.setToastPopUp({
                show: true,
                toastType: "error",
                message: "Fail to update URL",
              }),
            );
          }

          storeDispatch({
            type: "set-liveUrlUpdateLoader",
            value: false,
          });

          break;
        }
        default: {
          console.warn(`Unknown event: ${event.data}`);
          break;
        }
      }
    }

    if (fromOutgrow) {
      window.addEventListener("message", handler);
    }

    return () => {
      if (fromOutgrow) {
        window.removeEventListener("message", handler);
      }
    };
  }, [store.botData]);
}

export type CbbEvent =
  | { type: "navigate"; payload: { route: string } }
  | { type: "publishBot" }
  | { type: "changeBotName"; payload: { name: string } }
  | { type: "changeBotUrl"; payload: { url: string } }
  | { type: "syncUpdatedAt" };

export type OutgrowEvent = {
  type: "changeBotOgUrl";
  payload: {
    success: boolean;
    url: string;
  };
};
